import {useState} from 'react';
import {Button, Input, Row} from 'antd';
import {insertTaskNote} from "../../api/Api";
import {TASK_NOTES_MAX_LENGTH} from "../../api/Constants";
import {TaskStatusType} from "../../api/Constants";

const {TextArea} = Input;

export const NewTaskNotesWidget = ({task, onApiFail, onRefresh, props}) => {
    const [notes, setNotes] = useState(undefined);


    const clearForm = () => {
        setNotes(undefined);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const onClick = () => {
        console.log(`save it`);
        insertTaskNote(task.id, notes).then(r => {
            if (onRefresh) onRefresh();
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        }).finally(() => {
            clearForm();
        })

    }

    const rowStyle= {
        marginTop: '5px', marginBottom: '10px'
    }

    const okDisabled = task.status === TaskStatusType.Verified;

    return <div>
        <Row style={rowStyle}>
            <TextArea value={notes} placeholder={`new notes`} rows={6} maxLength={TASK_NOTES_MAX_LENGTH} showCount onChange={onNotesChange}/>
        </Row>
        <Row>
            <Button onClick={onClick} disabled={okDisabled}>Ok</Button>
        </Row>
    </div>
}